
import type { PropOptions } from 'vue';
import Vue from 'vue';
import PlusIcon from './images/plus-icon.vue.svg';

export default Vue.extend({
  name: 'PortfolioSectionField',
  components: {
    PlusIcon,
  },
  props: {
    label: {
      type: String,
      required: true,
    } as PropOptions<string>,
    value: {
      type: [String, Number],
      default: '',
    } as PropOptions<string | number>,
    secure: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    attributeName: {
      type: String,
      default: null,
    } as PropOptions<string>,
    mode: {
      type: String,
      default: 'view',
    } as PropOptions<string>,
  },
  computed: {
    displayValue(): string | null {
      if (this.secure) return '••••••';
      if (!this.value) return null;

      return String(this.value).trim();
    },
  },
});
